import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import signinComponent from './signin.component';
import formComponent from './component/form.component';

import SigninService from './service/signin.service';

let signinModule = angular.module('signin', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';
  $stateProvider
  .state('signin', {
    url: '/sign-in',
    component: 'signin',
    resolve: {
      authenticate: (SecurityService, SessionService, $state, $location) => {
        const fromMobile = $location.search().from;
        if (SecurityService.isSessionActive() && fromMobile !== 'mob') {
          // We don't want to display sign-page to user when he is logged in. Automatically
          // transition to dashboard instead.
          // This will cause transition rejection, but again, that would be fine.
          $state.go('dashboard');
        }
      }
    }
  })
  ;
})
.component('signin', signinComponent)
.component('signinForm', formComponent)
.service('SigninService', SigninService)
.name;

export default signinModule;



// WEBPACK FOOTER //
// ./client/app/pages/signin/signin.js